import { defineComponent, computed, ref, useTemplateRef, watch, onMounted, openBlock, createElementBlock, createElementVNode, normalizeClass, Fragment, renderList, normalizeStyle, withModifiers, createVNode, unref, withCtx, createCommentVNode } from "vue";
import { CdrButton, IconArrowLeft, IconArrowRight } from "@rei/cedar";
const _hoisted_1 = {
  class: "location-images-carousel"
};
const _hoisted_2 = ["id", "src", "aspect-ratio", "alt"];
const _hoisted_3 = {
  key: 0,
  class: "location-images-carousel__navigation",
  "data-ui": "loc-img-scroll-bar"
};
const _hoisted_4 = ["aria-valuenow"];
const _hoisted_5 = {
  class: "location-images-carousel__arrows"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LocationImages",
  props: {
    images: {}
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const computedLandscapeCount = computed(() => {
      const {
        images
      } = props;
      const landscapeCount = images.slice(0, 3).reduce((landscapeImgCount, currentImg) => {
        if (currentImg.maxWidth > currentImg.maxHeight) return landscapeImgCount + 1;
        return landscapeImgCount;
      }, 0);
      return landscapeCount >= 2 ? 2 : 3;
    });
    const computedImages = computed(() => {
      const {
        images
      } = props;
      if (images.length === 1) {
        if (images[0].maxWidth > images[0].maxHeight) {
          return [{
            ...images[0],
            styleWidth: "100%"
          }];
        }
        return [];
      }
      const firstImages = images.slice(0, computedLandscapeCount.value);
      const totalAspectRatio = firstImages.reduce((totalValue, currentValue) => totalValue + currentValue.maxWidth / currentValue.maxHeight, 0);
      const peekFactor = images.length > computedLandscapeCount.value ? 0.95 : 1;
      return images.map((img) => {
        const widthValue = img.maxWidth * peekFactor / img.maxHeight / totalAspectRatio * 100;
        return {
          ...img,
          styleWidth: `${widthValue}%`
        };
      });
    });
    const isHovered = ref(false);
    const isGrabbed = ref(false);
    const imageRefs = useTemplateRef("imageRefs");
    const currentIndex = ref(0);
    const containerRef = ref();
    const barWidth = ref(0);
    const scrollRatio = ref(0);
    const scrollBarRef = useTemplateRef("scrollBarRef");
    const scrollBarThumb = ref();
    const dragStartX = ref(0);
    const initialThumbOffset = ref(0);
    const atScrollStart = ref(true);
    const atScrollEnd = ref(false);
    const scrollPercentage = ref(0);
    watch(scrollRatio, () => {
      if (!containerRef.value) return;
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = containerRef.value;
      const percentScroll = scrollLeft / (scrollWidth - clientWidth) * 100;
      atScrollStart.value = percentScroll === 0;
      atScrollEnd.value = percentScroll === 100;
      scrollPercentage.value = Math.round(percentScroll * 1e3) / 1e3;
    });
    const modifyIsHovered = (bool) => {
      isHovered.value = bool;
    };
    const setIsGrabbed = (bool) => {
      isGrabbed.value = bool;
    };
    const updateBarWidth = () => {
      const el = containerRef.value;
      if (!el) return;
      const ratio = containerRef.value.clientWidth / containerRef.value.scrollWidth;
      barWidth.value = ratio;
    };
    onMounted(() => {
      var _a;
      updateBarWidth();
      (_a = imageRefs.value) == null ? void 0 : _a.forEach((img) => {
        if (img.complete) ;
        else {
          img.addEventListener("load", () => {
            updateBarWidth();
          });
        }
      });
    });
    function onScroll() {
      const el = containerRef.value;
      if (!el) return;
      const scrollBar = scrollBarRef.value;
      if (!scrollBar) return;
      const ratio = el.scrollLeft / (el.scrollWidth - el.clientWidth);
      scrollRatio.value = ratio * scrollBar.clientWidth * (1 - barWidth.value);
    }
    function updateBarPosition(newPosition) {
      var _a, _b, _c;
      if (!scrollBarRef.value) return;
      const trackWidth = (_a = scrollBarRef.value) == null ? void 0 : _a.offsetWidth;
      const scrollWidth = (_b = containerRef.value) == null ? void 0 : _b.scrollWidth;
      const clientWidth = (_c = containerRef.value) == null ? void 0 : _c.clientWidth;
      const maxThumbOffset = trackWidth - scrollBarThumb.value.offsetWidth;
      const scrollRatio2 = newPosition / maxThumbOffset;
      const maxScrollLeft = scrollWidth - clientWidth;
      containerRef.value.scrollLeft = scrollRatio2 * maxScrollLeft;
    }
    function onThumbBarDown(e) {
      if (!scrollBarRef.value) return;
      setIsGrabbed(true);
      dragStartX.value = e.clientX;
      const {
        transform
      } = window.getComputedStyle(scrollBarThumb.value);
      const match = /matrix\(([^]+)\)/.exec(transform);
      const currentTranslate = match ? parseFloat(match[1].split(",")[4]) : 0;
      const scrollBarPixelWidth = barWidth.value * scrollBarRef.value.clientWidth * 0.5;
      let offset = 0;
      const scrollBarWidth = barWidth.value * scrollBarRef.value.clientWidth;
      const isLeftOfBar = e.clientX < currentTranslate;
      const isRightOfBar = e.clientX > currentTranslate + scrollBarWidth;
      if (isLeftOfBar || isRightOfBar) {
        offset = e.clientX - currentTranslate - scrollBarPixelWidth;
      }
      initialThumbOffset.value = currentTranslate + offset;
      updateBarPosition(initialThumbOffset.value);
      window.addEventListener("mousemove", onThumbDrag);
      window.addEventListener("mouseup", stopThumbDrag);
    }
    function onThumbDrag(e) {
      var _a;
      if (!isGrabbed.value) return;
      if (!scrollBarRef.value) return;
      const trackWidth = (_a = scrollBarRef.value) == null ? void 0 : _a.offsetWidth;
      const maxThumbOffset = trackWidth - scrollBarThumb.value.offsetWidth;
      const deltaX = e.clientX - dragStartX.value;
      let newThumbOffset = initialThumbOffset.value + deltaX;
      newThumbOffset = Math.max(0, Math.min(newThumbOffset, maxThumbOffset));
      updateBarPosition(newThumbOffset);
    }
    function stopThumbDrag() {
      setIsGrabbed(false);
      updateVisibileIndex();
      window.removeEventListener("mousemove", onThumbDrag);
      window.removeEventListener("mouseup", stopThumbDrag);
    }
    function updateVisibileIndex() {
      var _a;
      if (!containerRef.value) return;
      (_a = imageRefs.value) == null ? void 0 : _a.forEach((img, index) => {
        if (img.offsetLeft > containerRef.value.offsetWidth) {
          currentIndex.value = index;
        }
      });
    }
    const getNextVisibleIndex = () => {
      if (!containerRef.value || !imageRefs.value) return currentIndex.value;
      const {
        scrollLeft
      } = containerRef.value;
      const containerRight = scrollLeft + containerRef.value.clientWidth;
      for (let i = 0; i < imageRefs.value.length; i++) {
        const img = imageRefs.value[i];
        const imgLeft = img.offsetLeft;
        const imgRight = imgLeft + img.offsetWidth;
        if (imgRight > containerRight) {
          return i;
        }
      }
      return imageRefs.value.length - 1;
    };
    const getPreviousVisibleIndex = () => {
      if (!containerRef.value || !imageRefs.value) return currentIndex.value;
      const {
        scrollLeft
      } = containerRef.value;
      for (let i = imageRefs.value.length - 1; i >= 0; i--) {
        const img = imageRefs.value[i];
        const imgLeft = img.offsetLeft;
        const imgRight = imgLeft + img.offsetWidth;
        if (imgRight < scrollLeft) {
          return i;
        }
      }
      return 0;
    };
    const scrollToImage = (index) => {
      var _a;
      const img = (_a = imageRefs.value) == null ? void 0 : _a[index];
      if (containerRef.value && img) {
        containerRef.value.scrollTo({
          left: img.offsetLeft,
          behaviour: "smooth"
        });
        currentIndex.value = index;
      }
    };
    const prevImage = () => {
      if (containerRef.value) {
        const prevIndex = getPreviousVisibleIndex();
        scrollToImage(prevIndex);
      }
    };
    const nextImage = () => {
      if (containerRef.value) {
        const nextIndex = getNextVisibleIndex();
        scrollToImage(nextIndex);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", {
        id: "location-images-carousel",
        ref_key: "containerRef",
        ref: containerRef,
        class: normalizeClass(["location-images-carousel__scroll-container", {
          "location-images-carousel__scroll-container--no-scroll": computedImages.value.length <= computedLandscapeCount.value
        }]),
        onScrollOnce: _cache[0] || (_cache[0] = ($event) => {
          emit("metricsClick", {
            linkName: `location image_scroll`
          });
        }),
        onScroll
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(computedImages.value, (img, index) => {
        return openBlock(), createElementBlock("img", {
          id: img.uri,
          key: `${img.uri}-${index}`,
          ref_for: true,
          ref_key: "imageRefs",
          ref: imageRefs,
          class: "location-images__image",
          src: img.uri,
          style: normalizeStyle({
            width: img.styleWidth,
            minWidth: img.styleWidth
          }),
          "aspect-ratio": img.maxWidth / img.maxHeight,
          loading: "lazy",
          alt: img.altText
        }, null, 12, _hoisted_2);
      }), 128))], 34), computedImages.value.length > computedLandscapeCount.value ? (openBlock(), createElementBlock("section", _hoisted_3, [createElementVNode("div", {
        ref_key: "scrollBarRef",
        ref: scrollBarRef,
        class: "location-images-carousel__nav-bar",
        "data-ui": "loc-img-scroll-container",
        role: "scrollbar",
        "aria-controls": "location-images-carousel",
        "aria-valuenow": scrollPercentage.value,
        "aria-orientation": "horizontal",
        onMouseenter: _cache[1] || (_cache[1] = ($event) => modifyIsHovered(true)),
        onMouseleave: _cache[2] || (_cache[2] = ($event) => modifyIsHovered(false)),
        onMousedown: withModifiers(onThumbBarDown, ["prevent"]),
        onMouseup: _cache[3] || (_cache[3] = ($event) => setIsGrabbed(false))
      }, [createElementVNode("div", {
        ref_key: "scrollBarThumb",
        ref: scrollBarThumb,
        class: normalizeClass({
          "location-images-carousel__nav-handle": true,
          "location-images-carousel__nav-handle--hover": isHovered.value,
          "location-images-carousel__nav-handle--grabbing": isGrabbed.value
        }),
        style: normalizeStyle({
          "--bar-width": barWidth.value,
          transform: `translateX(${scrollRatio.value}px)`
        }),
        "data-ui": "loc-img-thumb-scroll"
      }, null, 6)], 40, _hoisted_4), createElementVNode("div", _hoisted_5, [createVNode(unref(CdrButton), {
        "icon-only": true,
        disabled: atScrollStart.value,
        "data-ui": "loc-img-carousel-prev-button",
        onClick: prevImage
      }, {
        default: withCtx(() => [_cache[4] || (_cache[4] = createElementVNode("span", {
          class: "pdp-sr-only"
        }, "Click to previous image", -1)), createVNode(unref(IconArrowLeft))]),
        _: 1,
        __: [4]
      }, 8, ["disabled"]), createVNode(unref(CdrButton), {
        "icon-only": true,
        disabled: atScrollEnd.value,
        "data-ui": "loc-img-carousel-next-button",
        onClick: nextImage
      }, {
        default: withCtx(() => [_cache[5] || (_cache[5] = createElementVNode("span", {
          class: "pdp-sr-only"
        }, "Click to next image", -1)), createVNode(unref(IconArrowRight))]),
        _: 1,
        __: [5]
      }, 8, ["disabled"])])])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=LocationImages2.mjs.map
